import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, Input } from '@angular/core';
import { HeadCategory } from '../../../interfaces/routering/head-category';
import { SubCategory } from '../../../interfaces/routering/sub-category';
import { SidenavService } from '../sidenav.service';

@Component({
  selector: 'fury-sidenav-item',
  templateUrl: './sidenav-item.component.html',
  styleUrls: ['./sidenav-item.component.scss'],
  animations: [
    trigger('dropdownOpen', [
      state('false', style({
        height: 0
      })),
      state('true', style({
        height: '*'
      })),
      transition('false <=> true', animate('300ms cubic-bezier(.35, 0, .25, 1)'))
    ])
  ]
})
export class SidenavItemComponent {

  @Input() item: HeadCategory = null;
  @Input() parent: HeadCategory = null;

  public dropdownOpen: number[] = [];

  constructor(private sidenavService: SidenavService) {
  }

  toggleCheckbox(): void {
    const isHead: boolean = !this.parent;
    const parentId: number = isHead ? this.item.id : this.parent.id;
    const subId: number = isHead ? undefined : this.item.id;

    const allSubIds: number[] = isHead && this.item.sub_categories?.length
      ? this.item.sub_categories.map((s: SubCategory): number => s.id)
      : undefined;

    this.sidenavService.toggle(parentId, subId, allSubIds);
  }

  isChecked(): boolean {
    const isHead: boolean = !this.parent;
    const parentId: number = isHead ? this.item.id : this.parent.id;
    const subId: number = isHead ? undefined : this.item.id;

    const allSubIds: number[] = isHead && this.item.sub_categories?.length
      ? this.item.sub_categories.map((s: SubCategory): number => s.id)
      : undefined;

    return this.sidenavService.isChecked(parentId, subId, allSubIds);
  }

  isIndeterminate(): boolean {
    if (this.parent) {
      return false;
    }
    const allSubIds: number[] = this.item.sub_categories?.map((s: SubCategory): number => s.id) ?? [];
    return this.sidenavService.isIndeterminate(this.item.id, allSubIds);
  }

  togglePanel(item: HeadCategory | SubCategory): void {
    const index: number = this.dropdownOpen.findIndex((d: number): boolean => d === item.id);

    if (index !== -1) {
      this.dropdownOpen.splice(index, 1);
    } else {
      this.dropdownOpen.push(item.id);
    }
  }
}
